import React from "react";
import LoginForm from "./LoginForm";

const Login = () => {
  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="login-box">
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default Login;
